export default {"src":"/_next/static/media/MenuBgImage2.6400df4b.svg","height":170,"width":291,"blurWidth":0,"blurHeight":0};